import React, { useEffect, useState } from "react";
import arrow from "icons/dropdown_arrow_purple.svg";
import UsersItem from "layout/systemAdmin/users/UsersItem";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import plus from "icons/plus-purple.svg";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { sortObjectArrayComparator } from "utils";
import { setSortBy } from "slices/systemAdmin/systemAdminSlice";
import {
  WORKSPACES,
  FILTER_MEMBERS,
  FILTER_NON_MEMBERS,
  USERNAME,
  FILTER_SYSTEM_ADMINS,
  FILTER_LICENSED,
} from "constants/systemAdmin";

const UsersContentBody = ({ users }) => {
  const dispatch = useDispatch();
  const sortByState = useSelector((state) => state.systemAdmin.sortBy);
  const filterOption = useSelector((state) => state.systemAdmin.filterUsers);
  const userSearchTerm = useSelector(
    (state) => state.systemAdmin.userSearchTerm
  );

  const [display, setDisplay] = useState(users);

  const handleFilter = (user) => {
    if (filterOption === FILTER_NON_MEMBERS) {
      return user.workspaces === null;
    }
    if (filterOption === FILTER_MEMBERS) {
      return user.workspaces !== null;
    }
    if (filterOption === FILTER_SYSTEM_ADMINS) {
      return user.systemAdmin;
    }
    if (filterOption === FILTER_LICENSED) {
      return user.licensed;
    }
    return true;
  };

  const handleSearch = (user) => {
    if (userSearchTerm) {
      return (
        user.username.toLowerCase().includes(userSearchTerm?.toLowerCase()) ||
        user.firstName.toLowerCase().includes(userSearchTerm?.toLowerCase()) ||
        user.lastName.toLowerCase().includes(userSearchTerm?.toLowerCase())
      );
    }
    return true;
  };

  const handleSort = (column) => {
    if (column === sortByState.column) {
      dispatch(setSortBy({ ...sortByState, desc: !sortByState.desc }));
    } else {
      dispatch(setSortBy({ column, desc: true }));
    }
  };

  const getClassName = (column) => {
    if (sortByState.column === column) {
      return sortByState.desc ? "desc" : "asc";
    }
    return "";
  };

  const systemAdminUsers = users?.filter((user) => user.systemAdmin).length;

  const newUserButton = () => (
    <Button
      dataTestId="newUserButton"
      onClick={() => {
        dispatch(showModal(modalTypes.NEW_USER));
      }}
      variant={buttonVariants.borderless}
      content={
        <div>
          <img src={plus} alt="plus" />
          <span>New User</span>
        </div>
      }
    />
  );

  useEffect(() => {
    setDisplay(
      users
        ?.filter(handleFilter)
        .filter(handleSearch)
        .sort(sortObjectArrayComparator(sortByState.desc, sortByState.column))
    );
  }, [userSearchTerm, filterOption, sortByState, users]);

  return (
    <>
      <div
        className="users__container__header"
        data-testid="users-content-body"
      >
        <div>
          <button
            className="sortable"
            type="button"
            onClick={() => {
              handleSort(USERNAME);
            }}
          >
            <span>User Name</span>
            {sortByState.column === USERNAME ? (
              <img src={arrow} alt="arrow" className={getClassName(USERNAME)} />
            ) : null}
          </button>
        </div>
        <div>
          <button
            className="sortable"
            type="button"
            onClick={() => {
              handleSort(WORKSPACES);
            }}
          >
            <span>Workspace</span>
            {sortByState.column === WORKSPACES ? (
              <img
                src={arrow}
                alt="arrow"
                className={getClassName(WORKSPACES)}
              />
            ) : null}
          </button>
        </div>
        <span>System Admin</span>
        <span>First Name</span>
        <span>Last Name</span>
        <span>Last Active</span>
        <span>Actions</span>
      </div>
      {display?.map((user) => (
        <UsersItem user={user} systemAdminUsers={systemAdminUsers} />
      ))}
      <div className="users__container__add__member">{newUserButton()}</div>
    </>
  );
};

export default UsersContentBody;

UsersContentBody.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      workspaces: PropTypes.arrayOf(PropTypes.string),
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      lastActive: PropTypes.string,
    })
  ).isRequired,
};
